export default "__VITE_ASSET__BygmRYT0__"